import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { DataLayer } from '@grandvisionhq/analytics';
import { WizardProgress } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { isValidStepKey, bookAppointmentStepClickEvent } from '../../data-layer/actions.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import { useDisableSteps } from './hooks/use-disabled-steps.js';
import { mapStepToRoute, steps } from './steps.js';
import useVirtualAppointment from '../../pages/BookAppointment/hooks/use-virtual-appointment.js';

const NavigationContainer = (_param)=>{
    var { className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className"
    ]);
    const { getLabel  } = useIntl();
    const [{ goTo  }, { queryParams , currentRoute  }] = useRoutingContext();
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const labels = React.useMemo(()=>[
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[0]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[1]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[2]}`),
            getLabel(`appointments.component.navigationContainer.step.${mapStepToRoute[3]}`), 
        ]
    , [
        getLabel
    ]);
    var _currentRoute;
    const active = (_currentRoute = steps[currentRoute]) !== null && _currentRoute !== void 0 ? _currentRoute : steps.where;
    const onStepClick = React.useCallback((_, index)=>{
        /** Do not do anything if clicking on the active */ if (active === index) {
            return;
        }
        const targetRoute = mapStepToRoute[index];
        const dataLayerSteps = {
            '': 1,
            where: 1,
            what: 2,
            when: 3,
            who: 4
        };
        if (isValidStepKey(currentRoute, dataLayerSteps) && isValidStepKey(targetRoute, dataLayerSteps)) {
            const dataLayerEvent = bookAppointmentStepClickEvent({
                store: store && !isVirtualAppointmentType(type) ? {
                    code: store.code,
                    streetName: store.streetName,
                    town: store.town,
                    name: store.name,
                    postalCode: store.postalCode,
                    streetNumber: store.streetNumber,
                    additionalStreetInfo: store.additionalStreetInfo
                } : undefined,
                appointment: type ? {
                    appointmentType: {
                        id: type.id,
                        ageGroup: type.ageGroup,
                        isVirtualAppointment: isVirtualAppointmentType(type)
                    },
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                } : undefined
            }, dataLayerSteps, currentRoute, targetRoute);
            DataLayer.pushEvent(dataLayerEvent);
        }
        switch(index){
            /** On Where route click remove all query params from url */ case 0:
                {
                    const { typeId , search , userLocation  } = queryParams;
                    setStore(null);
                    setTimeSlot(null);
                    goTo(targetRoute, {
                        typeId,
                        search,
                        userLocation
                    });
                    return;
                }
            /** On What route click should keep only storeId parameter in url */ case 1:
                {
                    const { storeId , search , userLocation  } = queryParams;
                    setType(null);
                    setTimeSlot(null);
                    goTo(targetRoute, {
                        storeId,
                        search,
                        userLocation
                    });
                    return;
                }
            /** On When route click remove start and end from query params */ case 2:
                {
                    const restQueryParams = swcHelpers.objectWithoutProperties(queryParams, [
                        "start",
                        "end"
                    ]);
                    setTimeSlot(null);
                    goTo(targetRoute, restQueryParams);
                    return;
                }
            default:
                {
                    goTo(targetRoute, queryParams);
                    return;
                }
        }
    }, [
        goTo,
        store,
        type,
        timeSlot,
        setType,
        setTimeSlot,
        setStore,
        isVirtualAppointmentType,
        currentRoute,
        active,
        queryParams, 
    ]);
    const disabledSteps = useDisableSteps(active, queryParams);
    /** If has typeId in the url and active step is Where, skip What step
   * The same logic for virtual appointment typeId
   */ const skippedSteps = React.useMemo(()=>queryParams.typeId && active === steps.where ? [
            steps.what
        ] : []
    , [
        queryParams,
        active
    ]);
    return /*#__PURE__*/ React.createElement(WizardProgress, swcHelpers.extends({}, rest, {
        className: classnames('book-appointment-navigation', className),
        steps: labels,
        active: active,
        disableSteps: disabledSteps,
        onClick: onStepClick,
        skipSteps: skippedSteps
    }));
};
var NavigationContainer$1 = NavigationContainer;

export { NavigationContainer$1 as default };
//# sourceMappingURL=NavigationContainer.js.map
